import React, { lazy, memo } from 'react';
import { BookOpenIcon, CalendarIcon, ListChecksIcon, ChefHatIcon, PiggyBankIcon } from 'lucide-react';
const Features = () => {
  return <div className="w-full bg-[#DEEFE1] py-10 md:py-16" data-id="element-75">
      <div className="container mx-auto px-4" data-id="element-76">
        <div className="text-center mb-6 md:mb-12" data-id="element-77">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 md:mb-4" data-id="element-78">
            ¿Qué incluye "La Cena Que Te Salva"?
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-79">
            Todo lo que necesitas para transformar la hora de la cena
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-8 max-w-4xl mx-auto" data-id="element-80">
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md flex items-start" data-id="element-81">
            <BookOpenIcon className="w-8 h-8 md:w-10 md:h-10 text-[#438A52] mr-3 flex-shrink-0 mt-1" data-id="element-82" />
            <div data-id="element-83">
              <h3 className="font-bold text-lg mb-1 text-[#438A52]" data-id="element-84">
                10 Recetas Latinas Rápidas
              </h3>
              <p className="text-sm md:text-base text-gray-700" data-id="element-85">
                Recetas auténticas en 30 minutos con ingredientes accesibles.
              </p>
            </div>
          </div>
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md flex items-start" data-id="element-86">
            <CalendarIcon className="w-8 h-8 md:w-10 md:h-10 text-[#438A52] mr-3 flex-shrink-0 mt-1" data-id="element-87" />
            <div data-id="element-88">
              <h3 className="font-bold text-lg mb-1 text-[#438A52]" data-id="element-89">
                Menú Semanal Planificado
              </h3>
              <p className="text-sm md:text-base text-gray-700" data-id="element-90">
                Plan de comidas para 2 semanas, organizado día por día.
              </p>
            </div>
          </div>
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md flex items-start" data-id="element-91">
            <ListChecksIcon className="w-8 h-8 md:w-10 md:h-10 text-[#438A52] mr-3 flex-shrink-0 mt-1" data-id="element-92" />
            <div data-id="element-93">
              <h3 className="font-bold text-lg mb-1 text-[#438A52]" data-id="element-94">
                Lista de Compras Editable
              </h3>
              <p className="text-sm md:text-base text-gray-700" data-id="element-95">
                Organizada por secciones del supermercado, ahorra tiempo y
                dinero.
              </p>
            </div>
          </div>
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md flex items-start" data-id="element-96">
            <ChefHatIcon className="w-8 h-8 md:w-10 md:h-10 text-[#438A52] mr-3 flex-shrink-0 mt-1" data-id="element-97" />
            <div data-id="element-98">
              <h3 className="font-bold text-lg mb-1 text-[#438A52]" data-id="element-99">
                Técnicas de Cocina Rápida
              </h3>
              <p className="text-sm md:text-base text-gray-700" data-id="element-100">
                Secretos para cocinar más rápido y maximizar el sabor.
              </p>
            </div>
          </div>
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md flex items-start col-span-1 md:col-span-2" data-id="element-101">
            <PiggyBankIcon className="w-8 h-8 md:w-10 md:h-10 text-[#438A52] mr-3 flex-shrink-0 mt-1" data-id="element-102" />
            <div data-id="element-103">
              <h3 className="font-bold text-lg mb-1 text-[#438A52]" data-id="element-104">
                Estrategias de Ahorro Comprobadas
              </h3>
              <p className="text-sm md:text-base text-gray-700" data-id="element-105">
                Ahorra hasta 40% en tu presupuesto con nuestras estrategias de
                compra.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-8 md:mt-12 text-center" data-id="element-106">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sB4reBVsxqrnWpicYVWZPv/Ebook_7_recetas_imagen_916_%281080_x_1080_px%29_%281%29.webp" alt="Comidas nutritivas latinas preparadas" className="w-full max-w-2xl mx-auto rounded-lg shadow-lg" loading="lazy" width="768" height="768" data-id="element-107" />
          <p className="mt-3 md:mt-4 text-base md:text-lg text-[#438A52] font-medium" data-id="element-108">
            Platos nutritivos y deliciosos listos en menos de 30 minutos
          </p>
        </div>
      </div>
    </div>;
};
export default memo(Features);